import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Text, TextLink } from '@/components/base/text'
import { Divider } from '@/components/base/divider'
import { Subheading } from '@/components/base/heading'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline'

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const SupportDialog = ({ open, setOpen }: Props) => {
  return (
    <Dialog open={open} size="5xl" onClose={setOpen}>
      <DialogTitle>
        <div className="flex items-center justify-around">
          <span className="text-xl">How can we help you today?</span>
        </div>
      </DialogTitle>
      <DialogBody>
        <div className="grid grid-cols-2 py-6 items-center">
          <EnvelopeIcon className="justify-self-center size-24" />
          <div>
            <Subheading>Drop us an email</Subheading>
            <Text>
              Have you got a question, need a hand with something, or maybe<br />
              you've got an idea that would make Ripple more useful for you?
            </Text>
            <br />
            <Text>
              We're always available at&nbsp;
              <TextLink href="mailto:support@rippleassetmanagement.co.uk">
                support@rippleassetmanagement.co.uk
              </TextLink>.<br />
              Send us a message any time and we'll get back to you as soon as possible
            </Text>
          </div>
        </div>
        <Divider />
        <div className="grid grid-cols-2 py-6 items-center">
          <PhoneIcon className="justify-self-center size-24" />
          <div>
            <Subheading>Give us a ring</Subheading>
            <Text>
              Is it something more urgent? Or do you just fancy a chat with us?
            </Text>
            <br />
            <Text>
              Give us a bell at <TextLink href="tel:+441182112038">+44 (0) 118 211 2038</TextLink>, we're always happy
              to help out!
            </Text>
          </div>
        </div>
        <Divider />
        <Text className="pt-6 text-balance text-center">
          We're also on Instagram (@rippleassetmanagement), LinkedIn, and X (@rippleassetmgmt) if you want to keep up
          with all the cool new things we're doing
        </Text>
      </DialogBody>
    </Dialog>
  )
}
